import { AppShell } from "@/layouts/AppShell";

export function PlatformLayout() {
  return <AppShell />;
}
